export default __webpack_public_path__ + "static/media/ldo_NEG_FIX_nEN.097a6c2e.svg";